import { render, staticRenderFns } from "./water-activities-in-goa.vue?vue&type=template&id=311ffec4&scoped=true"
import script from "./water-activities-in-goa.vue?vue&type=script&lang=js"
export * from "./water-activities-in-goa.vue?vue&type=script&lang=js"
import style0 from "./water-activities-in-goa.vue?vue&type=style&index=0&id=311ffec4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311ffec4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainCategoryCard: require('/workspace/components/MainCategoryCard.vue').default,PopularCategoryCard: require('/workspace/components/PopularCategoryCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
